import React, { useState, useContext } from 'react';
import { Popover, Radio, message } from 'antd';
import { getConsolidateVariableContract } from '../../../utils/services/channelAPI';
import {
    Container,
    PopupContainer,
    SampleSection,
    InputSection,
    SectionTitle,
    ActionButton,
} from './styles';
import { AppStoreContext } from '../../../context/appStoreContext';
import { getSampleDataSet } from '../../../utils/helper';
import { jsonToFile, xmlToFile } from '../../../utils/javascript';
import { getXMLFromJSON } from '../../../utils/transactionHelpers';
import { generateSampleExcel } from '../../../utils/transactionHelpers';
import { withTranslation } from 'react-i18next';
import { FILTER_PANEL } from './translationValues';
import { downloadDelimitedFile, generateCSVHeadersFromJSON } from '../../../utils/helper';
import { dynamicTableHasMoreThanTwoLevels } from '../complexDocumentHelper';

const NAMESPACES = ['FILTER_PANEL']

const HoverDropdownButton = ({ t, communicationId, visible }) => {

    const { globalVariables } = useContext(AppStoreContext);

    const [env, setEnv] = useState('draft');
    const [isVisible, setIsVisible] = useState(visible);
    const [fileFormat, setFileFormat] = useState('excel');
    const [delimiter, setDelimiter] = useState('tsv');


    const downloadSampleFile = (dataset = {}, response) => {
        const effectiveFormat = fileFormat === 'TXT' ? delimiter : fileFormat;
        switch (effectiveFormat) {
            case 'excel':
                const variableContract = {
                    variableContract: response.variableContract,
                    passwordProtected: response.passwordProtected,
                    name: `${response?.communicationName}-sample`,
                    env: env
                }
                generateSampleExcel(variableContract, false, false, undefined, true, t);
                break;
            case 'json':
                jsonToFile(dataset, `${response?.communicationName}-sample`);
                break;
            case 'xml':
                const req = { request: dataset };
                const xmlString = getXMLFromJSON({ requests: req }, {}, true);
                xmlToFile(xmlString, `${response?.communicationName}-sample`);
                break;
            case 'csv':
            case 'tsv':
            case 'psv':
                const headers = generateCSVHeadersFromJSON(dataset);
                const templateName = `${response?.communicationName}`;
                downloadDelimitedFile({ templateName, headers, format: effectiveFormat, rows: [], env: env });
                break;
            default:
                break;
        }
    }

    const handleDownload = async () => {
        if (!env) return;
        try {
            const payload = {
                communicationId: communicationId,
            };
            const response = await getConsolidateVariableContract(payload, env);
            if (response?.statusCode === 200) {
                const effectiveFormat = fileFormat === 'TXT' ? delimiter : fileFormat;
                let dataset;
                if (effectiveFormat === 'csv' || effectiveFormat === 'tsv' || effectiveFormat === 'psv') {
                    if (response?.data?.variableContract?.length > 0) {
                        const { hasMoreThanTwoLevels } = dynamicTableHasMoreThanTwoLevels(response.data.variableContract);
                        if (hasMoreThanTwoLevels) {
                            message.warning(t(
                                FILTER_PANEL.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key,
                                FILTER_PANEL.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value,
                            ));
                            return;
                        }
                    }
                    dataset = getSampleDataSet(response?.data?.variableContract, globalVariables, 'flatFile/communication', env, true);
                }
                else {
                    dataset = getSampleDataSet(response?.data?.variableContract, globalVariables, 'communication', env, true);
                }
                downloadSampleFile(dataset, response?.data);
            }
            else {
                message.error(t(
                    FILTER_PANEL.FAILURE_MESSAGE.key,
                    FILTER_PANEL.FAILURE_MESSAGE.value
                ));
            }
        } catch (error) {
            message.error(t(
                FILTER_PANEL.FAILURE_MESSAGE.key,
                FILTER_PANEL.FAILURE_MESSAGE.value
            ));
        }
        finally {
            setIsVisible(false);
        }
    };

    const content = () => (
        <PopupContainer>
            <SampleSection>

                <InputSection>
                    <SectionTitle>
                        {t(
                            FILTER_PANEL.CHOOSE_ENVIRONMENT.key,
                            FILTER_PANEL.CHOOSE_ENVIRONMENT.value,
                        )}
                    </SectionTitle>
                    <Radio.Group
                        onChange={e => setEnv(e.target.value)}
                        value={env}
                        style={{ display: 'flex', gap: 6 }}
                    >
                        <div style={{ display: 'flex', gap: 22, alignItems: 'center' }}>
                            <Radio value="draft">Draft</Radio>
                            <Radio style={{marginRight:'0px'}} value="sandbox">Sandbox</Radio>
                            <Radio style={{marginLeft: '0px'}} value="live">Live</Radio>
                        </div>
                    </Radio.Group>
                </InputSection>

                <InputSection>
                    <SectionTitle>
                        {t(
                            FILTER_PANEL.FILE_FORMAT.key,
                            FILTER_PANEL.FILE_FORMAT.value,
                        )}
                    </SectionTitle>
                    <Radio.Group
                        onChange={e => {
                            const value = e.target.value;
                            if (value === 'TXT') {
                                setFileFormat('TXT');
                            }
                            else {
                                setDelimiter('tsv');
                                setFileFormat(value);
                            }
                        }}
                        value={fileFormat}
                        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
                    >
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                            <Radio value="excel">
                                Excel
                            </Radio>
                            <Radio value="json">
                                JSON
                            </Radio>
                            <Radio style={{marginLeft: '8px'}}value="xml">
                                XML
                            </Radio>
                        </div>
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                            <Radio value="csv">
                                CSV
                            </Radio>
                            <Radio style={{ marginLeft: '5px' }} value="TXT">
                                Text
                            </Radio>
                        </div>
                    </Radio.Group>
                </InputSection>

                <div style={{
                    display: 'grid',
                    gridTemplateRows: fileFormat === 'TXT' ? '1fr' : '0fr',
                    transition: 'grid-template-rows 0.3s ease-out',
                }}>
                    <div style={{ overflow: 'hidden' }}>
                        <InputSection style={{
                            marginTop: '12px',
                            opacity: fileFormat === 'TXT' ? 1 : 0,
                            transition: 'opacity 0.3s ease-in-out'
                        }}>
                            <SectionTitle>Choose Delimiter</SectionTitle>
                            <Radio.Group
                                onChange={e => setDelimiter(e.target.value)}
                                value={delimiter}
                                style={{ display: 'flex', flexDirection: 'row', gap: 30 }}
                            >
                                <Radio value="tsv">
                                    Tab 
                                </Radio>
                                <Radio value="psv">
                                    Pipe 
                                </Radio>
                            </Radio.Group>
                        </InputSection>
                    </div>
                </div>

                <ActionButton type="filled" onClick={() => { handleDownload() }}>
                    {t(
                        FILTER_PANEL.DOWNLOAD_REQUEST_SAMPLE.key,
                        FILTER_PANEL.DOWNLOAD_REQUEST_SAMPLE.value,
                    )}
                </ActionButton>
            </SampleSection>
        </PopupContainer>
    );

    return (
        <Container>
            <Popover
                getPopupContainer={trigger => trigger.parentNode}
                visible={isVisible}
                content={content()}
                placement="rightTop"
                align={{ offset: [0, -35] }}
            />
        </Container>
    );
};

export default withTranslation(NAMESPACES)(HoverDropdownButton);
